define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Quadrant = exports.Vector2 = void 0;
    class Vector2 {
        constructor(x, y) {
            this.x = x;
            this.y = y;
        }
        plus(u) {
            return new Vector2(this.x + u.x, this.y + u.y);
        }
        minus(u) {
            return new Vector2(this.x - u.x, this.y - u.y);
        }
        multiply(c) {
            return new Vector2(this.x * c, this.y * c);
        }
        dotProduct(u) {
            return this.x * u.x + this.y * u.y;
        }
        divide(c) {
            return new Vector2(this.x / c, this.y / c);
        }
        equals(u) {
            return this.x === u.x && this.y === u.y;
        }
        isZero() {
            return this.x === 0 && this.y === 0;
        }
        round() {
            return new Vector2(Math.floor(this.x + 0.5), Math.floor(this.y + 0.5));
        }
        length() {
            return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
        }
    }
    exports.Vector2 = Vector2;
    var Quadrant;
    (function (Quadrant) {
        Quadrant[Quadrant["TopRight"] = 1] = "TopRight";
        Quadrant[Quadrant["TopLeft"] = 2] = "TopLeft";
        Quadrant[Quadrant["BottomLeft"] = 3] = "BottomLeft";
        Quadrant[Quadrant["BottomRight"] = 4] = "BottomRight";
    })(Quadrant = exports.Quadrant || (exports.Quadrant = {}));
});
//# sourceMappingURL=types.js.map